import { createFileRoute } from "@tanstack/react-router";
import SvgOptimizerPage from "@/pages/SvgOptimizerPage";

export const Route = createFileRoute("/tools/svg-optimizer")({
  component: SvgOptimizerPage,
});
